import { render, staticRenderFns } from "./FormProcessDesign2.vue?vue&type=template&id=6756b719&scoped=true"
import script from "./FormProcessDesign2.vue?vue&type=script&lang=js"
export * from "./FormProcessDesign2.vue?vue&type=script&lang=js"
import style0 from "./FormProcessDesign2.vue?vue&type=style&index=0&id=6756b719&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6756b719",
  null
  
)

export default component.exports